// extracted by mini-css-extract-plugin
module.exports = {"root":"BankTransfer_root__3CEob","container":"BankTransfer_container__3DP6L","btn":"BankTransfer_btn__399bD","rotate":"BankTransfer_rotate__29_r_"};